export default {"src":"/_next/static/media/sand.5e032fe3.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};